import IInitializableModule, { BaseInitializableModule } from '../Core/IInitializableModule.js';
import IConfig from '../AppConfig.js';
import IStateReducerInfo from '../Core/IStateReducerInfo.js';
import IEpiserverContext from '../Core/IEpiserverContext.js';
import { DefaultServices } from '../Core/IServiceContainer.js';
import CmsStateReducer, { PartialAppState, ContentAppState as CmsAppState } from './Reducer.js';
import * as Tools  from './Tools.js';
import IContentDeliveryAPI from '../ContentDelivery/IContentDeliveryAPI.js';

export class StateModule extends BaseInitializableModule implements IInitializableModule
{
    protected name: string = "Core State Engine";

    public SortOrder : number = 40;

    public StartModule(context: IEpiserverContext): void
    {
        const store = context.getStore();
        const state = store.getState() as PartialAppState;
        const cfg : Readonly<IConfig> = context.serviceContainer.getService<IConfig>(DefaultServices.Config);
        const cdAPI : IContentDeliveryAPI = context.serviceContainer.getService<IContentDeliveryAPI>(DefaultServices.ContentDeliveryAPI_V2);

        // Setup CD-API Language to respond to the state changes.
        Tools.observeStore<string, CmsAppState>(
            store, 
            (x) => x?.OptiContentCloud?.currentLanguage || cfg.defaultLanguage,
            (newValue) => {
                if (newValue) cdAPI.Language = newValue;
            }
        );

        // Make sure the current language is applied
        const language = state?.OptiContentCloud?.currentLanguage
        if (!language)
            store.dispatch({
                type: "OptiContentCloud/SetState",
                currentLanguage: cfg.defaultLanguage
            })
        else
            cdAPI.Language = language || cfg.defaultLanguage;

    }

    /**
     * Return the standard state reducer for the CMS Status
     */
    public GetStateReducer : () => IStateReducerInfo<any> = () => CmsStateReducer;
}

export default StateModule;